import { render, staticRenderFns } from "./RecruiterQaStatusPill.vue?vue&type=template&id=511b6ac6&scoped=true"
import script from "./RecruiterQaStatusPill.vue?vue&type=script&lang=js"
export * from "./RecruiterQaStatusPill.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaStatusPill.vue?vue&type=style&index=0&id=511b6ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b6ac6",
  null
  
)

export default component.exports